import store from '@/store'

export function hasPermi(value) {
  const allPermission = '*:*:*'
  const permissions = store.getters && store.getters.permissions
  if (value && value instanceof Array && value.length > 0) {
    const permissionFlag = value
    const hasPermissions = permissions.some(permission => {
      return allPermission === permission || permissionFlag.includes(permission)
    })
    return hasPermissions
  } else {
    throw new Error(`请设置操作权限标签值`)
  }
}
